import React from 'react'
import './EditLinkPage.css'
import { LINK_VIEW_MODES } from 'constants/general.constants'
import LinkView from 'components/LinkView/LinkView'

export default function EditLinkPage() {
    return (
        <LinkView mode={LINK_VIEW_MODES.EDIT} />
    )
}